<template>
    <div class="login-page">
        <div class="login-box">
            <div class="card card-outline card-primary">
                <div class="card-header text-center">
                    <a href="#" class="h1">SendAll</a>
                </div>
                <div class="card-body">
                     <confirm-email v-show="$route.params.tokenId"></confirm-email>
                    <p v-show="error === '' && success === '' " class="text-center text-bold text-gray">
                        {{ $t('message.login_message') }}</p>
                    <div v-if="error !== ''" class="alert flat alert-danger alert-dismissible pl-3 pr-5">
                        <button type="button" @click="resetMsg" class="close" data-dismiss="alert"
                            aria-hidden="true">×</button>
                        <p><i class="icon fa fa-exclamation-triangle"></i>{{$t('message.401_error')}}</p>
                        &nbsp;{{error}}
                    </div>
                    <div v-if="((success !== '') && (!success.title))"
                        class="alert flat bg-green disabled alert-dismissible pl-3 pr-5">
                        <button type="button" @click="resetMsg" class="close" data-dismiss="alert"
                            aria-hidden="true">×</button>
                        <p>
                            <i class="icon fa fa-check"></i>{{$t('message.session_close')}}</p>
                        &nbsp;{{success}}
                    </div>
                    <div v-else-if="(success.title)" class="alert flat bg-green disabled alert-dismissible pl-3 pr-5">
                        <button type="button" @click="resetMsg" class="close" data-dismiss="alert"
                            aria-hidden="true">×</button>
                        <p> <i class="icon fa fa-check"></i>{{success.title}} </p>
                        &nbsp;{{success.message}}
                    </div>
                    <div class="form-group">
                        <input type="text" name="email" :class="{ 'is-invalid': errors.has('email') }"
                            v-model="request.email" class="form-control" v-bind:placeholder="$t('attributes.email')"
                            v-validate="'required|email'" @keyup.enter="signIn()" @keyup="clearSignInError()">
                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
                    </div>
                    <div class="form-group">
                        <input type="password" name="password" :class="{ 'is-invalid': errors.has('password') }"
                            v-model="request.password" class="form-control"
                            v-bind:placeholder="$t('attributes.password')" v-validate="'required|min:4'"
                            @keyup.enter="signIn()" @keyup="clearSignInError()">
                        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                        <div class="invalid-feedback help-block error">{{errors.first('password')}}</div>
                    </div>
                    <div class="row mx-0 align-items-center justify-content-around">
                        <div class="col-md-8 px-0">
                            <p-check class="p-switch p-fill" v-model="request.remember" color="primary">
                                {{$t('message.remember')}}
                            </p-check>
                        </div>
                        <div class="col-md-4 px-0">
                            <button type="button" @click="signIn()" :disabled="loading" class="btn btn-primary w-100">
                                <span class="px-2">{{ $t('words.sign_in') }}</span> <i v-show="loading"
                                    class="fa fa-circle-o-notch fa-spin"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <!-- <router-link to="/password/recovery">{{ $t('words.i_forgot_my_password') }}</router-link> -->
                            <router-link to="/password/recovery">{{ $t('words.i_forgot_my_password') }}</router-link>
                        </div>
                    </div>
                    <div class="row justify-content-center my-3">
                        <router-link class="exp" :to="{ name: 'signup' }"> Cadastre aqui </router-link>
                    </div>
                </div>
            </div>
        </div>
        <m-two-factory-email ref="mTwoFactoryEmail" :request="request"></m-two-factory-email>
        <m-two-factory-google ref="mTwoFactoryGoogle" :request="request"></m-two-factory-google>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';
    import MTwoFactoryEmail from './components/m-two-factory-email.vue';
    import MTwoFactoryGoogle from './components/m-two-factory-google.vue';
    import confirmEmail from './ConfirmEmail.vue';
    export default {
        components: {
            confirmEmail,
            MTwoFactoryEmail,
            MTwoFactoryGoogle
        },
        data() {
            return {
                request: {
                    email: '',
                    password: null,
                    remember: false,
                    companyId: null,
                    token_otp: null
                },
                loading: false,
                error: '',
                success: '',
                loginMsg: '',
                companies: [],
            }
        },
        beforeMount() {
            setTimeout(() => {
                this.cookies = Cookies.get('politica')
            }, 1500);
        },
        methods: {
            setCookie() {
                this.cookies = true;
                Cookies.set('politica', this.cookies, {
                    expires: 365
                })
                this.$forceUpdate()
            },
            resetMsg() {
                this.message = '';
                this.error = '';
            },
            signIn() {
                this.request.email = this.request.email.replace(/\s/g, '');
                this.$validator.validateAll(['email', 'password']).then(valid => {
                    if (!valid) {
                        return;
                    }
                    this.loading = true;
                    this.$auth.login(this.request)
                        .then(response => {
                            if (response.data.access_token) {
                                window.location.href = "/dashboard";
                            } else {
                                this.$refs.mChoiceCompany.show(response);
                            }
                        }).catch(error => {
                            if (error.data.two_factory) {
                                this.showTwoFactoryModal(error);
                                return;
                            }
                            if (typeof error.data.message != 'undefined') {
                                toastr({
                                    icon: error.data.status,
                                    title: error.data.message
                                });
                            }
                        }).finally(fn => {
                            this.loading = false;
                        })
                });
            },
            clearSignInError() {
                this.signin_error = null;
            },
            showTwoFactoryModal(error) {
                error.data.two_factory == 'E' ?
                    this.$refs.mTwoFactoryEmail.show(error) : this.$refs.mTwoFactoryGoogle.show(error);
            }
        }
    }
</script>

<style scoped>
    #app .container {
        max-width: 100%;
    }

    #first {
        height: 100vh;
        background-color: darkgray !important;
    }

    img {
        width: 100%;
        height: 100%;

        position: fixed;
        left: 0;
        z-index: -999;
    }
  
    /* ----- SECTION-LOGIN ----- */
    #section-login {
        width: 100%;
        height: 100vh;
        position: absolute;
        right: 3vh;
    }


    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }

    @keyframes home {
        from {
            transform: translateX(30vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .router-anim-bg-enter-active {
        animation: coming-bg 0.6s;
        animation-duration: 1s;
    }

    .router-anim-bg-leave-active {
        animation: going-bg 0.6s;
        animation-duration: 1s;
    }

    @keyframes coming-bg {
        from {
            transform: translateX(100vw);
        }

        to {
            transform: translateX(0);
        }
    }

    @keyframes going-bg {
        from {
            transform: translateX(0);
        }

        to {
            transform: translateX(-100vw);
        }
    }

    /* ----- SECTION-HOME ----- */
    #section-home {
        color: #fff;
        width: 100vw;
    }

    #section-home ul {
        list-style: none;
        align-items: center;
        justify-content: space-between;
    }

    #section-home li a {
        padding: 1rem;
        transition: all 0.3s;
        font-size: 16px;
        color: #fff;
        font-family: "Montserrat";
        font-weight: 300;
        line-height: 1.3;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
    }

    #section-home li:hover a {
        color: #ff7f00;
        text-decoration: underline;
        border-radius: 5px;
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    @media screen and (max-width: 767px) {
        #section-login {
            max-width: 50%;
            right: auto;
        }
    }

    @media screen and (max-width: 576px) {
        #section-login {
            max-width: 100%;
            right: 0;
        }
    }

    @media screen and (max-width: 991px) {
        img {
            width: auto;
        }

        @keyframes home {
            from {
                transform: translateX(100vw);
            }

            to {
                transform: translateX(0);
            }
        }
    }

    #cookies {
        border-radius: 5px;
        bottom: 1rem;
        left: 0;
        z-index: 9999;
        -webkit-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        -moz-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
    }

    .anim-cookies-enter-active {
        animation: cookies 0.6s;
    }

    .anim-cookies-leave-active {
        animation: cookies 0.6s;
        animation-direction: reverse;
    }

    @keyframes cookies {
        from {
            transform: translateY(10vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }
</style>